const COMPANY_LIST_KEY = 'userCompanyList';
const SETTING_LIST_KEY = 'userSettingList';
const SELECTED_COMPANY_INDEX_KEY = 'selectedCompanyIndex';

function parseStorageArray(key) {
    const value = localStorage.getItem(key);
    if (value == null || value === '') {
        return [];
    }
    return JSON.parse(value);
}

function storeCompanyAndSettingList(companyList, settingList, logoPath) {
    const activeCompanyList = companyList.filter(company => company.syncStatus !== 1);
    const activeCompanyUUIDSet = new Set(activeCompanyList.map(company => company.innerUUID));
    const activeSettingList = settingList.filter(setting =>
        setting.syncStatus !== 1
        && activeCompanyUUIDSet.has(setting.companyUUID)
    );
    localStorage.setItem(COMPANY_LIST_KEY, JSON.stringify(activeCompanyList));
    localStorage.setItem(SETTING_LIST_KEY, JSON.stringify(activeSettingList));
    if (logoPath !== undefined) {
        localStorage.setItem('logoPath', logoPath);
    }
}

function findCompanyIndex(companyList, companyUUID) {
    if (companyUUID == null || companyUUID === '') {
        return 0;
    }
    const index = companyList.findIndex(company => company.innerUUID === companyUUID);
    if (index === -1) {
        return 0;
    }
    return index;
}

function findSettingByCompanyUUID(settingList, companyUUID) {
    const setting = settingList.find(item => item.companyUUID === companyUUID);
    if (setting == null) {
        throw new Error('Setting not found for selected company');
    }
    return setting;
}

export function getStoredCompanyList() {
    return parseStorageArray(COMPANY_LIST_KEY);
}

export function getStoredSettingList() {
    return parseStorageArray(SETTING_LIST_KEY);
}

export function getSelectedCompanyIndex() {
    const selectedCompanyIndex = localStorage.getItem(SELECTED_COMPANY_INDEX_KEY);
    if (selectedCompanyIndex == null || selectedCompanyIndex === '') {
        return 0;
    }
    const parsedIndex = parseInt(selectedCompanyIndex, 10);
    if (Number.isNaN(parsedIndex)) {
        return 0;
    }
    return parsedIndex;
}

export function getCurrentCompany() {
    const userCompany = localStorage.getItem('userCompany');
    if (userCompany == null || userCompany === '') {
        return null;
    }
    return JSON.parse(userCompany);
}

export function getCurrentSetting() {
    const userSetting = localStorage.getItem('userSetting');
    if (userSetting == null || userSetting === '') {
        return null;
    }
    return JSON.parse(userSetting);
}

export function getCurrentCompanyUUID() {
    const userCompany = getCurrentCompany();
    if (userCompany == null) {
        return '';
    }
    return userCompany.innerUUID;
}

export function applyCompanySelectionByIndex(index) {
    const companyList = getStoredCompanyList();
    const settingList = getStoredSettingList();
    if (companyList.length === 0) {
        return null;
    }
    const selectedIndex = index >= 0 && index < companyList.length ? index : 0;
    const selectedCompany = companyList[selectedIndex];
    const selectedSetting = findSettingByCompanyUUID(settingList, selectedCompany.innerUUID);

    localStorage.setItem(SELECTED_COMPANY_INDEX_KEY, String(selectedIndex));
    localStorage.setItem('userCompany', JSON.stringify(selectedCompany));
    localStorage.setItem('userSetting', JSON.stringify(selectedSetting));

    return {
        company: selectedCompany,
        setting: selectedSetting,
        index: selectedIndex
    };
}

export function applyCompanySelectionByUUID(companyUUID) {
    const companyList = getStoredCompanyList();
    const index = companyList.findIndex(company => company.innerUUID === companyUUID);
    if (index === -1) {
        throw new Error('Selected company is not present in local company list');
    }
    return applyCompanySelectionByIndex(index);
}

export function initializeCompanySelection(data) {
    storeCompanyAndSettingList(data.companyList, data.settingList, data.logoPath);
    return applyCompanySelectionByIndex(0);
}

export function syncCompanySelection(data) {
    const currentCompanyUUID = getCurrentCompanyUUID();
    storeCompanyAndSettingList(data.companyList, data.settingList, data.logoPath);
    return applyCompanySelectionByIndex(findCompanyIndex(getStoredCompanyList(), currentCompanyUUID));
}

export function replaceStoredCompany(company) {
    const companyList = getStoredCompanyList();
    const index = companyList.findIndex(item => item.innerUUID === company.innerUUID);
    if (index === -1) {
        throw new Error('Updated company is not present in local company list');
    }
    companyList.splice(index, 1, company);
    localStorage.setItem(COMPANY_LIST_KEY, JSON.stringify(companyList));
    const currentCompany = getCurrentCompany();
    if (currentCompany != null && currentCompany.innerUUID === company.innerUUID) {
        localStorage.setItem('userCompany', JSON.stringify(company));
    }
}

export function replaceStoredSetting(setting) {
    const settingList = getStoredSettingList();
    const index = settingList.findIndex(item => item.innerUUID === setting.innerUUID);
    if (index === -1) {
        throw new Error('Updated setting is not present in local setting list');
    }
    settingList.splice(index, 1, setting);
    localStorage.setItem(SETTING_LIST_KEY, JSON.stringify(settingList));
    const currentSetting = getCurrentSetting();
    if (currentSetting != null && currentSetting.innerUUID === setting.innerUUID) {
        localStorage.setItem('userSetting', JSON.stringify(setting));
    }
}
